// extracted by mini-css-extract-plugin
module.exports =  {"infoBlock":"mmcVzmvi86xnrjxgH8ik","rowLabel":"gRy7NFJU5WJ8V6BrtKGc","collectedData":"KbbmOhlLaCusBAtw71ke"};